import { Component, OnInit } from '@angular/core';
import { SnAuthUser, SnAuthService } from '@insight/serenity-auth';
import { AppInsightsService } from './shared/services/app-insights.service';
import { TitleService } from './shared/services/title.service';
import { ApiConfiguration } from './shared/api/api-configuration';
import { environment } from '../environments/environment';
import { PermissionsService } from './shared/services/permissions.service';
import { EngieApmService } from 'platops-npm-apm';
import { OktaAuthService } from '@okta/okta-angular';

@Component({
  selector: 'e2cb-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {
  public user: SnAuthUser;
  public hasAppAccess = false;
  public constructor(
    private _okta: OktaAuthService,
    private _titleService: TitleService,
    private _appInsightService: AppInsightsService,
    private _authService: SnAuthService,
    private _apiConfig: ApiConfiguration,
    public _permissionsService: PermissionsService,
  ) {
    const authCheckInterval = setInterval(() => {
      this._okta.isAuthenticated().then(isAuthenticated => {
        console.log(`checking if user is authenticated: ${isAuthenticated}`);
        if (isAuthenticated) {
          clearInterval(authCheckInterval);

          _titleService.Title = 'Client Billing';
          this.handlePersonas();
        }
      });
    }, 250);

    this._authService.user$.subscribe(async user => {
      console.log('logged in as ', user);
      this.user = user;
      try {
        EngieApmService.setUser(this.user.identityProviderId, `${this.user.firstName} ${this.user.lastName}`, this.user.email);
      } catch (e) { console.error(e); }
    });

    this._authService.events.onLogout.subscribe(user => {
      alert('Your Session Has Timed Out.');
    });

    let apiUrl =  environment.settings.api_url;
    apiUrl = apiUrl.charAt(apiUrl.length - 1) === '/' ? apiUrl.slice(0, -1) : apiUrl;

    this._apiConfig.rootUrl = apiUrl;
  }

  navigationLinks: navigationLinks[] = [
    {
      icon: 'fa-home',
      text: ' Home',
      link: 'landing'
    },
    {
      icon: 'fa-clipboard-list',
      text: ' Manual Usage',
      link: 'manual-usage-landing'
    },
    {
      icon: 'fa-chart-bar',
      text: ' Reporting',
      link: 'bulk-usage'
    },
    {
      icon: 'fa-table',
      text: ' Aggregation',
      link: 'aggregation'
    },
    {
      icon: 'fa-paper-plane',
      text: ' Transmit Data',
      link: 'aggregation-transmit'
    },
    {
      icon: 'fa-folder',
      text: ' File Portal',
      link: 'file-portal'
    },
    {
      icon: 'fa-cog',
      text: ' Data File Config',
      link: 'file-config'
    },
    {
      icon: 'fa-user-cog',
      text: ' Client Config',
      link: 'client-configure'
    }
  ];

  async ngOnInit() {
  }

  async handlePersonas() {
    this.hasAppAccess = await this._permissionsService.hasApplicationAccess();

    this.navigationLinks = this.navigationLinks.filter(navLink => {
      return this._permissionsService.canAccessRoute(navLink.link);
    })

  }

  // ------------------------------------------------------------

  public setTitle(newTitle: string) {
    this._titleService.Title = newTitle;
  }

  // ------------------------------------------------------------
  public logout() {
    this._authService.logout();
  }

  // ------------------------------------------------------------

  public get NavService() {
    return this._titleService;
  }

  // ------------------------------------------------------------
}

interface navigationLinks {
  icon?: string,
  text: string,
  link: string
}